import {
    apiRequest,
    PetaJabatanList,
    PetaJabatanExport,
    PetaJabatanExportRekap,
    workUnitList,
    PetaJabatanNewExport,
    exportTemplatePetaJabatan,
    importDataPetaJabatan,
    checkmutasipegawai
  } from "../../../../../services/adapters/kepegawaian/PetaJabatanService";
  
  class DetailRepository {
    fetchList = async (query, cancelToken) => {
      return await apiRequest(
        "get",
        PetaJabatanList,
        {
          cancelToken: cancelToken,
          params: query,
        },
        true
      );
    };
  
    fetchExportExcel = async (query) => {
      return await apiRequest(
        "get",
        PetaJabatanExport,
        {
          params: query,
        },
        true
      );
    };
  
    fetchExportRekap = async (query) => {
      return await apiRequest(
        "get",
        PetaJabatanExportRekap,
        {
          params: query,
        },
        true
      );
    };
  
    fetchWorkUnit = async (query) => {
      return await apiRequest(
        "get",
        workUnitList,
        {
          params: query,
        },
        true
      );
    };
  
    fetchExportNew = async (query) => {
      return await apiRequest(
        "get",
        PetaJabatanNewExport,
        {
          params: query,
        },
        true
      );
    };

    fetchexportTemplatePetaJabatan = async (query) => {
      return await apiRequest(
        "get",
        exportTemplatePetaJabatan,
        {
          params: query,
        },
        true
      );
    };

    fetchimportDataPetaJabatan = async (query) => {
      return await apiRequest(
        "post",
        importDataPetaJabatan,
        {
          body: query,
        },
        true
      );
    };

     fetchcheckmutasipegawai = async (query) => {
        return await apiRequest('get', checkmutasipegawai, {
            params: query,
        }, true)
    }
     
  }
  
  export default DetailRepository;